import { render } from "./personalCenter.vue?vue&type=template&id=1b692d6c&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"

import "./personalCenter.vue?vue&type=style&index=0&id=1b692d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b692d6c"]])

export default __exports__